import classnames from "classnames";
import { ReactNode } from "react";

export const DialogActions = ({
  children,
  className,
}: {
  children?: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classnames("grow-0 shrink-0 px-6 pb-4 border-top", className)}
    >
      <div
        className={classnames(
          "tw-flex tw-items-center tw-justify-end tw-space-x-6 tw-pt-4",
        )}
      >
        {children}
      </div>{" "}
    </div>
  );
};
